var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('img',{attrs:{"src":_vm.$generateAssetsUrl(_vm.logo),"alt":"logo"}}):_c('img',{attrs:{"src":"/img/icons/app-icon-example.png","alt":"app-icon-jrm","width":"512","height":"512"}})}
var staticRenderFns = []

export { render, staticRenderFns }